import { useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { printerLog } from '@/apis/aipass'
import { checkinEposPrinterIdStorage } from '@/constants/self-checkin-device-storage'
import { PrinterContextCreator } from '@/contexts/printer'
import { toErrorMessage } from '@/libs/errors'
import { SelfCheckInState } from '@/models/self-checkin'
import { SelfCheckOutState } from '@/models/self-checkout'
import { useCustomScript } from '@/hooks/use-custom-script'

type FrontTabletState = SelfCheckInState | SelfCheckOutState

export const useInitializeFrontTablet = (state?: FrontTabletState): void => {
  const { connect, isConnected } = useContext(PrinterContextCreator())
  const { search } = useLocation()
  const hotelIdFromQuery = new URLSearchParams(search).get('hotelId')
  const hotelId = hotelIdFromQuery || state?.hotelId

  useCustomScript(hotelId, state?._type)

  // context の値は再レンダリングごとに同一性が変わるため、依存に含めず hotelId 確定時のみ接続する
  useEffect(() => {
    if (!localStorage.getItem(checkinEposPrinterIdStorage)) {
      return
    }
    if (!hotelId) {
      return
    }
    // connect() は接続済みなら何もせず保持中の接続を返すため、新規接続時だけログを残せるよう事前の状態を控える
    const wasConnected = isConnected()
    connect({ hotelId, connectIdKey: checkinEposPrinterIdStorage })
      .then(() => {
        if (!wasConnected) {
          printerLog({ message: 'connect', mode: 'layout' })
        }
      })
      .catch(e => {
        printerLog({ message: `error. ${toErrorMessage(e)}`, mode: 'layout' })
        console.error(e)
      })
  }, [hotelId])
}
